import { PlannerProperty } from "./planner-property";

export const nameProperty = new PlannerProperty(
  'f4740e91-5fd0-4872-9bea-b07bbc0a8fd3',
  "Event Name",
)
